<ws-modal-wrapper headerLabel="Transfer"
                  acceptLabel="Transfer"
                  (save)="ok()"
                  (cancel)="cancel()">
    <div>
        Are you sure you want to start the transfer process?<br/>
        The following are the summary of actions:<br/>
        Insert: {{ params.evaluatedInsertCount | number }} rows<br/>
        Update: {{ params.evaluatedUpdateCount | number }} rows<br/>
        Delete: {{ params.evaluatedDeleteCount | number }} rows<br/>
        @if (isAssetsImport) {
            <span>Unchanged: {{ params.evaluatedNoChangeCount | number }} rows @if (params.evaluatedNoChangeCount) {
                <span>(recording assets appeared on import)</span>
            }</span>
        }<br/>
        <br/>
        @if (params.effectiveDate) {
            <span style="font-weight: bold">Effective date: {{ params.effectiveDate|date:'M/d/yyyy' }}</span>
        }<br/>
        @if (params.assetOwnershipType) {
            <span style="font-weight: bold">Asset Ownership type: {{ params.assetOwnershipType }}</span>
        }<br/>
        @if (params.accrualAdjustmentAmountValueType) {
            <span style="font-weight: bold">Amount Value type: {{ params.accrualAdjustmentAmountValueType }}</span>
        }
    </div>
</ws-modal-wrapper>
